// extracted by mini-css-extract-plugin
module.exports = {"layout":"BodyTopMainAppDownloadIphonePopup_layout_1fLG4","iPhonePopup":"BodyTopMainAppDownloadIphonePopup_iPhonePopup_17968"};